"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Container = require("../../components/Container/Container");

var _Column = require("../../components/Column/Column");

var _Row = require("../../components/Row/Row");

var _Box = require("../../components/Box/Box");

var _Button = _interopRequireDefault(require("../../components/Button/Button"));

var _Header = require("../../components/Header/Header");

var _Text = require("../../components/Text/Text");

var _Line = require("../../components/Line/Line");

var _SalesCalloutHomeTryon = _interopRequireDefault(require("../../components/SalesCalloutHomeTryon/SalesCalloutHomeTryon"));

var _SalesCalloutInspiration = _interopRequireDefault(require("../../components/SalesCalloutInspiration/SalesCalloutInspiration"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var MarketingModuleNextSteps =
/*#__PURE__*/
function (_Component) {
  _inherits(MarketingModuleNextSteps, _Component);

  function MarketingModuleNextSteps() {
    _classCallCheck(this, MarketingModuleNextSteps);

    return _possibleConstructorReturn(this, _getPrototypeOf(MarketingModuleNextSteps).apply(this, arguments));
  }

  _createClass(MarketingModuleNextSteps, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ctaPageName = _this$props.ctaPageName,
          getStartedCallout = _this$props.getStartedCallout,
          salesCallout1 = _this$props.salesCallout1,
          salesCallout2 = _this$props.salesCallout2,
          props = _objectWithoutProperties(_this$props, ["ctaPageName", "getStartedCallout", "salesCallout1", "salesCallout2"]);

      return _react.default.createElement(_react.default.Fragment, null, this.props.theme.brand === 'menguin' ? _react.default.createElement(_Box.Box, _extends({
        className: "next_steps_module",
        backgroundColor: "grayLighter"
      }, props), _react.default.createElement(_Line.Line, {
        lineColor: "grayLighter",
        strong: true
      }), _react.default.createElement(_Container.Container, {
        py: [5, 5, 5, 6, 6, 6]
      }, _react.default.createElement(_Row.Row, {
        flexWrap: true,
        alignItems: "stretch"
      }, _react.default.createElement(_Column.Column, {
        column: 12,
        columnSm: 4,
        columnLg: 6,
        display: "flex",
        alignItems: "stretch",
        mb: [3, 3, 0, 0, 0, 0]
      }, _react.default.createElement(_Box.Box, {
        backgroundColor: "white",
        px: [4, 6, 3, 4, 6, 6],
        py: [5, 5, 4, 4, 5, 5]
      }, _react.default.createElement(_Header.Header, {
        type: 2,
        size: 3,
        mb: 3
      }, "Get started."), getStartedCallout ? getStartedCallout : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Text.Text, {
        textColor: "grayDark",
        mb: 4
      }, "Stylish suits and tuxedos delivered straight to your door. See our collection and rent\xA0now."), _react.default.createElement(_Button.default, {
        block: true,
        buttonType: "info",
        mb: 3,
        className: "".concat(ctaPageName && "tracker-cta-".concat(ctaPageName, "-next_steps_module-view_collection-20190306-105512")),
        href: "/collection/tuxedos-and-suits"
      }, "View Collection"), _react.default.createElement(_Button.default, {
        block: true,
        outline: true,
        buttonType: "default",
        className: "".concat(ctaPageName && "tracker-cta-".concat(ctaPageName, "-next_steps_module-create_account-20190306-105512")),
        href: "/app/signup/email"
      }, "Create Account")))), _react.default.createElement(_Column.Column, {
        column: 12,
        columnXs: 6,
        columnSm: 4,
        columnLg: 3,
        display: "flex",
        mb: [3, 0, 0, 0, 0, 0]
      }, salesCallout1 ? salesCallout1 : _react.default.createElement(_SalesCalloutHomeTryon.default, {
        ctaPageName: ctaPageName
      })), _react.default.createElement(_Column.Column, {
        column: 12,
        columnXs: 6,
        columnSm: 4,
        columnLg: 3,
        display: "flex"
      }, salesCallout2 ? salesCallout2 : _react.default.createElement(_SalesCalloutInspiration.default, {
        ctaPageName: ctaPageName
      }))))) : _react.default.createElement(_Box.Box, _extends({
        className: "next_steps_module"
      }, props), _react.default.createElement(_Line.Line, {
        lineColor: "grayLighter",
        strong: true
      }), _react.default.createElement(_Container.Container, {
        py: [5, 5, 5, 6, 6, 6]
      }, _react.default.createElement(_Row.Row, {
        flexWrap: true,
        alignItems: "stretch"
      }, _react.default.createElement(_Column.Column, {
        column: 0,
        columnLg: 1
      }), _react.default.createElement(_Column.Column, {
        column: 12,
        columnXs: 4,
        columnSm: 4,
        columnLg: 3,
        display: "flex",
        flexFlow: "column wrap",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        mb: [4, 0, 0, 0, 0, 0]
      }, _react.default.createElement(_Header.Header, {
        headline: true,
        type: 2,
        size: 2
      }, "Get started."), _react.default.createElement(_Line.Line, {
        headlineDivider: true,
        lineColor: "gray"
      }), getStartedCallout ? getStartedCallout : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Text.Text, {
        mb: [3, 3, 3, 4, 4, 4]
      }, "Stylish suits and tuxedos delivered straight to your door. See our collection and rent\xA0now."), _react.default.createElement(_Button.default, {
        block: true,
        buttonType: "info",
        mb: 3,
        className: "".concat(ctaPageName && "tracker-cta-".concat(ctaPageName, "-next_steps_module-view_collection-20190306-105512")),
        href: "/collection/tuxedos-and-suits"
      }, "View Collection"), _react.default.createElement(_Button.default, {
        block: true,
        outline: true,
        buttonType: "default",
        className: "".concat(ctaPageName && "tracker-cta-".concat(ctaPageName, "-next_steps_module-create_account-20190306-105512")),
        href: "/app/signup/email"
      }, "Create Account"))), _react.default.createElement(_Column.Column, {
        column: 0,
        columnXs: 1,
        columnLg: 1
      }), _react.default.createElement(_Column.Column, {
        column: 12,
        columnXs: 7,
        columnSm: 7,
        columnLg: 6
      }, _react.default.createElement(_Row.Row, null, _react.default.createElement(_Column.Column, {
        column: 12
      }, _react.default.createElement(_Header.Header, {
        headline: true,
        type: 2,
        size: 2,
        mb: [3, 4, 4, 4, 4, 4]
      }, "Learn more."))), _react.default.createElement(_Row.Row, {
        alignItems: "stretch"
      }, _react.default.createElement(_Column.Column, {
        column: 6,
        display: "flex"
      }, salesCallout1 ? salesCallout1 : _react.default.createElement(_SalesCalloutHomeTryon.default, {
        ctaPageName: ctaPageName
      })), _react.default.createElement(_Column.Column, {
        column: 6,
        display: "flex"
      }, salesCallout2 ? salesCallout2 : _react.default.createElement(_SalesCalloutInspiration.default, {
        ctaPageName: ctaPageName
      }))))))));
    }
  }]);

  return MarketingModuleNextSteps;
}(_react.Component);

MarketingModuleNextSteps.propTypes = {
  ctaPageName: _propTypes.default.string.isRequired,
  getStartedCallout: _propTypes.default.object,
  salesCallout1: _propTypes.default.object,
  salesCallout2: _propTypes.default.object
}; // export default withTheme(MarketingModuleNextSteps);

var _default = (0, _styledComponents.withTheme)(MarketingModuleNextSteps);

exports.default = _default;